import React, { Component } from "react"
import styled from 'styled-components'
import { HashRouter as Router, Route } from 'react-router-dom'
import { media } from '../styles/vars'
import Index from '../pages/Index'
import Article from '../pages/Article'
import Loading from '../pages/Loading'
import Footer from './Footer'
import { SiteStorage } from '../storage'

const StyledApp = styled.div`
direction:rtl;
max-width:1920px;
overflow:hidden;
margin:0 auto;

.flowplayer span{
    font-size: 18px !important;
}
.flowplayer .fp-volume,
.flowplayer .fp-qsel{
    display:none !important;
}
.flowplayer .fp-icon:before{
    font-size:2rem;
}
${
    media.desktop`
    .flowplayer span{
        font-size: 24px !important;
    }
    .flowplayer .fp-volume{
        display:flex !important;
    }
    .flowplayer .fp-qsel{
        display:block !important;
    }
    `
    }
`
export default class App extends Component {
    constructor() {
        super();
        this.onLoaded = this.onLoaded.bind(this);
        this.state = {
            siteLoaded: SiteStorage.getLoaded()
        }
    }
    onLoaded() {
        SiteStorage.setLoaded();
        window.setTimeout(() => {
            this.setState({
                siteLoaded: true
            });
        }, 200);
    }
    render() {
        if (!this.state.siteLoaded) {
            return (
                <Router basename="/">
                    <Loading onLoaded={this.onLoaded} />
                </Router>
            )
        }
        return (
            <StyledApp>
                <Router basename="/">
                    <main>
                        <Route
                            path="/:section?"
                            component={Index}
                            exact
                        />
                        <Route
                            path="/article/:id"
                            component={Article}
                            exact
                        />
                    </main>
                </Router>
                <Footer />
            </StyledApp >
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/App.jsx